import React, { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';
import Themeroutes from './routes/Router';
import DefaultTheme from './layouts/theme/DefaultTheme';
import Loader from './layouts/loader/Loader';

const App = () => {
  const routing = useRoutes(Themeroutes);
  return (
    <Suspense fallback={<Loader />}>
      <div style={{ background: 'white' }}>
        <DefaultTheme />
        {routing}
      </div>
    </Suspense>
  );
};

export default App;
